import React from 'react';
import PropTypes from 'prop-types';
import {
  IconButton,
  InputAdornment,
  Modal,
  TextField,
  Typography,
} from '@material-ui/core';
import { AddCircle, DeleteForever } from '@material-ui/icons';
import { withStyles } from '@material-ui/styles';
import ReactTable from 'react-table';
import ActionButton from '../../../components/ActionButton';
import { reportError } from '../../../utils/reportApiError';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    textAlign: 'center',
    gap: theme.spacing(3),
    backgroundColor: 'white',
    color: 'black',
    padding: theme.spacing(3),
    borderRadius: '6px',
    boxShadow: theme.shadows[6],
    overflowY: 'auto',
    width: '90%',
    maxWidth: '960px',
  },
  inputWrapper: {
    width: '100%',
    maxWidth: '600px',
    '& .MuiInputBase-input': {
      textAlign: 'center', // Centra il testo all'interno del TextField
    },
  },
  tableWrapper: {
    width: '85%',
    overflowX: 'auto',
  },
  conformitaWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    width: '100%',
    maxWidth: 700,
  },
  rowWrapper: {
    display: 'grid',
    gridTemplateColumns: '130px 1fr',
    alignItems: 'center',
    columnGap: theme.spacing(3),
    width: '100%',
  },
  conformitaLabel: {
    justifySelf: 'end',
  },
});

class ModalAggiuntaValori extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnData: this.props.columnData,
      records: [],
      columns: [],
      newValue: '',
      isEditing: false,
      tableKey: 0,
    };
  }

  componentDidMount = () => {
    let valoriAggiuntiToPass =
      this.state.columnData[this.props.selectedIndex].valoriAggiunti;
    if (
      this.state.columnData[this.props.selectedIndex].valoriAggiunti === null
    ) {
      valoriAggiuntiToPass = [];
    }
    let a = this.getColumnsForModal();
    this.setState({
      columns: a,
      records: valoriAggiuntiToPass,
    });
  };

  deleteRow = (cellInfo) => {
    let recordsToChange = [...this.state.records];
    recordsToChange.splice(cellInfo._index, 1);
    this.setState({
      records: recordsToChange,
      isEditing: true,
    });
    this.setState((prevState) => ({ tableKey: prevState.tableKey + 1 }));
  };

  getColumnsForModal = () => {
    return [
      {
        Header: 'Valore',
        id: 'valore',
        minWidth: 480,
        accessor: (d) => d,
        Cell: (props) => (
          <TextField
            defaultValue={props.row.valore}
            onInput={(event) => {
              let arrayOfChange = [...this.state.records];
              arrayOfChange[props.row._index] = event.target.value;
              const caret = event.target.selectionStart;
              const element = event.target;
              window.requestAnimationFrame(() => {
                element.selectionStart = caret;
                element.selectionEnd = caret;
              });
              this.setState({ records: arrayOfChange, isEditing: true });
            }}
            inputProps={{ style: { textAlign: 'center' } }}
            style={{ width: '80%', margin: 10 }}
          />
        ),
      },
      {
        Header: 'Elimina',
        id: 'Elimina',
        width: 180,
        accessor: (d) => d,
        Cell: (props) => (
          <IconButton
            onClick={() => this.deleteRow(props.row)}
            title="Elimina"
            color="primary"
          >
            <DeleteForever />
          </IconButton>
        ),
      },
    ];
  };

  render() {
    const { classes } = this.props;
    const current = this.state.columnData[this.props.selectedIndex];
    const isConformita = current?.selectedTipo === 'conformita';

    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onClose}
        className={classes.modal}
      >
        <div className={classes.modalContainer}>
          {isConformita ? (
            <div className={classes.conformitaWrapper}>
              <Typography variant="h6" gutterBottom>
                Aggiungi valori
              </Typography>
              <div className={classes.rowWrapper}>
                <Typography className={classes.conformitaLabel}>
                  Conforme:
                </Typography>
                <TextField
                  value={this.state.records[0] || ''}
                  onChange={(event) => {
                    const arr = [...this.state.records];
                    arr[0] = event.target.value;
                    this.setState({ records: arr, isEditing: true });
                  }}
                  inputProps={{ style: { textAlign: 'center' } }}
                  margin="dense"
                />
              </div>
              <div className={classes.rowWrapper}>
                <Typography className={classes.conformitaLabel}>
                  Non conforme:
                </Typography>
                <TextField
                  value={this.state.records[1] || ''}
                  onChange={(event) => {
                    const arr = [...this.state.records];
                    arr[1] = event.target.value;
                    this.setState({ records: arr, isEditing: true });
                  }}
                  inputProps={{ style: { textAlign: 'center' } }}
                  margin="dense"
                />
              </div>
            </div>
          ) : (
            <>
              <TextField
                label="Inserisci un nuovo valore"
                value={this.state.newValue}
                className={classes.inputWrapper}
                onChange={(event) => {
                  const value = event.target.value;
                  this.setState({
                    newValue: value,
                    isEditing: true,
                  });
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        title="Aggiungi"
                        onClick={() => {
                          let arrayToChange = [...this.state.records];
                          arrayToChange.push(this.state.newValue);
                          this.setState({
                            records: arrayToChange,
                            newValue: '',
                            isEditing: true,
                          });
                        }}
                      >
                        <AddCircle color="primary" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <div className={classes.tableWrapper}>
                <ReactTable
                  key={this.state.tableKey}
                  filterable={false}
                  resizable={true}
                  enableEditing={true}
                  showPageSizeOptions={false}
                  showPageJump={true}
                  defaultPageSize={10}
                  style={{
                    height: 400,
                  }}
                  pages={this.state.totalPages}
                  data={this.state.records}
                  columns={this.state.columns}
                  previousText="Precedente"
                  nextText="Successivo"
                  noDataText="Nessun record"
                  pageText="Pagina"
                  ofText="di"
                  rowsText="righe"
                  pageJumpText="Vai a pagina"
                  rowsSelectorText="righe per pagina"
                  getTrProps={(state, rowInfo) => {
                    if (!rowInfo) return {};

                    return {
                      key: rowInfo.original.id || rowInfo.index, // assegna key stabile
                    };
                  }}
                />
              </div>
            </>
          )}
          <div>
            <ActionButton
              label="Chiudi"
              secondaryButton
              onClick={this.props.onClose}
            />
            <ActionButton
              label="Salva"
              onClick={() => {
                if (isConformita) {
                  if (
                    !this.state.records[0]?.trim() ||
                    !this.state.records[1]?.trim()
                  ) {
                    reportError(
                      'Entrambi i valori di conformità devono essere inseriti.',
                      'Attenzione',
                    );
                    return;
                  }
                  this.props.saveColumnData([
                    this.state.records[0].trim(),
                    this.state.records[1].trim(),
                  ]);
                  return;
                }
                const hasEmptyValues = this.state.records.some(
                  (value) => value.trim() === '',
                );

                if (hasEmptyValues) {
                  reportError(
                    'I valori aggiunti non devono essere vuoti.',
                    'Attenzione',
                  );
                  return;
                }
                this.props.saveColumnData(this.state.records);
              }}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

ModalAggiuntaValori.propTypes = {
  classes: PropTypes.object.isRequired,
  columnData: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  saveColumnData: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number.isRequired,
};

export default withStyles(styles)(ModalAggiuntaValori);
